import { Partner, SharesTitle } from 'types';
import { PartnerRow } from '../types/PartnerRow';

export const getPartnersDataFromTitle = (title: SharesTitle): PartnerRow[] => {
  const titlePartners = title?.partners || [];

  if (titlePartners?.length === 0) {
    return [];
  }

  const partnersData = titlePartners?.map((partner: Partial<Partner>) => ({
    id: partner._id,
    cif: partner.cif,
    name: partner.name,
  }));

  return partnersData as PartnerRow[];
};
